const withSessionMeta = sessions =>
	sessions.map((session, index) => ({
		...session,
		order: session.order ?? index + 1,
	}))

export const CURRICULUM_RESOURCE_TYPES = {
	PLAN: 'class-plan',
	SLIDES: 'slides',
	NOTES: 'presenter-notes',
}

export const GRADE_CURRICULUM_META = {
	9: {
		title: 'Grade 9 Core Curriculum',
		description:
			'Foundational sessions for early high school college readiness.',
	},
	10: {
		title: 'Grade 10 Core Curriculum',
		description:
			'Sessions focused on profile building and academic positioning.',
	},
	11: {
		title: 'Grade 11 Core Curriculum',
		description: 'Sequence of 6 sessions for junior year college prep.',
	},
	12: {
		title: 'Grade 12 Core Curriculum',
		description:
			'Final-year sessions for applications and submission readiness.',
	},
}

export const CURRICULUM_BY_GRADE = [
	{
		id: 'grade-9',
		grade: 9,
		title: 'Grade 9 Core Curriculum',
		sessions: withSessionMeta([
			{
				id: 'g9-session-1',
				order: 1,
				title: 'Career Quiz & Personality Review',
				assignmentType: 'career_quiz',
				resources: {
					plan: 'https://docs.google.com/document/d/1V0aAWpslLeT4gE6tLz3WFkj5eukcQS-WjQgK1X3dnJo/edit?usp=drive_link',
					slides:
						'https://docs.google.com/presentation/d/1-y2MOnvrbf82hcYW59FvLTJUEU5sxgLcph56PXbMO7c/edit?usp=drive_link',
				},
			},
			{
				id: 'g9-session-2',
				order: 2,
				title: 'Career Reflection Essay',
				assignmentType: 'career_essay',
				resources: {
					plan: 'https://docs.google.com/document/d/13yrd1OBu2WhI8QQcsg39nx36Y7UpvwVm/edit?usp=drive_link&ouid=101351132062150365714&rtpof=true&sd=true',
					slides:
						'https://docs.google.com/presentation/d/1qA6tSOO1tdPyuCYHxlpWrAG6fu7nH02e/edit?usp=drive_link&ouid=101351132062150365714&rtpof=true&sd=true',
				},
			},
			{
				id: 'g9-session-3',
				order: 3,
				title: 'Country & University Exploration',
				assignmentType: 'country_exploration',
				resources: {
					plan: 'https://docs.google.com/document/d/1-9ciTYI13VoEjuipah7oAGI7y6mNQhbN/edit?usp=drive_link&ouid=101351132062150365714&rtpof=true&sd=true',
					slides:
						'https://docs.google.com/presentation/d/1p64mdak7umGuH5yuYuY63yV3xdUVD1cs/edit?usp=drive_link&ouid=101351132062150365714&rtpof=true&sd=true',
				},
			},
			{
				id: 'g9-session-4',
				order: 4,
				title: 'Academic Track Alignment (Masar Selection)',
				assignmentType: 'pathway_alignment',
				resources: {
					plan: 'https://docs.google.com/document/d/1FqM3VbwMoG5anfGHeHP8eIepTsYLa6Px/edit?usp=drive_link&ouid=101351132062150365714&rtpof=true&sd=true',
					slides:
						'https://docs.google.com/presentation/d/1coJWh3-ts3TYvAjj-1FiCEboy8i_bP1C/edit?usp=drive_link&ouid=101351132062150365714&rtpof=true&sd=true',
				},
			},
			{
				id: 'g9-session-5',
				order: 5,
				title: 'Profile Building & Extracurriculars',
				assignmentType: 'profile_building',
				resources: {
					plan: 'https://docs.google.com/document/d/1BAhJ_xfR57_yD6Z2mnz9Tj8oxA1zixrq/edit?usp=drive_link&ouid=101351132062150365714&rtpof=true&sd=true',
					slides:
						'https://docs.google.com/presentation/d/1WRo2-4cZSavN3zZP5UBz-E8usxSGqrfU/edit?usp=drive_link&ouid=101351132062150365714&rtpof=true&sd=true',
				},
			},
			{
				id: 'g9-session-6',
				order: 6,
				title: 'Final 2-3 Minute Oral Presentation',
				assignmentType: 'class_presentation',
				resources: {
					plan: 'https://docs.google.com/document/d/1LqhgkE9azubnAGZjIdNCgGzv7gk8jvTD/edit?usp=drive_link&ouid=101351132062150365714&rtpof=true&sd=true',
					slides:
						'https://docs.google.com/presentation/d/14FQ44y7Bm8jrmNbIbhNH18PBwHwGdKtM/edit?usp=drive_link&ouid=101351132062150365714&rtpof=true&sd=true',
				},
			},
		]),
	},

	{
		id: 'grade-10',
		grade: 10,
		title: 'Grade 10 Core Curriculum',
		sessions: withSessionMeta([
			{
				id: 'g10-session-1',
				order: 1,
				title: 'Career Quiz & Personality Review',
				assignmentType: 'career_quiz',
				resources: {
					plan: 'https://docs.google.com/document/d/1V0aAWpslLeT4gE6tLz3WFkj5eukcQS-WjQgK1X3dnJo/edit?usp=drive_link',
					slides:
						'https://docs.google.com/presentation/d/1-y2MOnvrbf82hcYW59FvLTJUEU5sxgLcph56PXbMO7c/edit?usp=drive_link',
				},
			},
			{
				id: 'g10-session-2',
				order: 2,
				title: 'Career Reflection Essay',
				assignmentType: 'career_essay',
				resources: {
					plan: 'https://docs.google.com/document/d/13yrd1OBu2WhI8QQcsg39nx36Y7UpvwVm/edit?usp=drive_link&ouid=101351132062150365714&rtpof=true&sd=true',
					slides:
						'https://docs.google.com/presentation/d/1qA6tSOO1tdPyuCYHxlpWrAG6fu7nH02e/edit?usp=drive_link&ouid=101351132062150365714&rtpof=true&sd=true',
				},
			},
			{
				id: 'g10-session-3',
				order: 3,
				title: 'Country & University Exploration',
				assignmentType: 'country_exploration',
				resources: {
					plan: 'https://docs.google.com/document/d/1-9ciTYI13VoEjuipah7oAGI7y6mNQhbN/edit?usp=drive_link&ouid=101351132062150365714&rtpof=true&sd=true',
					slides:
						'https://docs.google.com/presentation/d/1p64mdak7umGuH5yuYuY63yV3xdUVD1cs/edit?usp=drive_link&ouid=101351132062150365714&rtpof=true&sd=true',
				},
			},
			{
				id: 'g10-session-4',
				order: 4,
				title: 'Academic Track Alignment (Masar Selection)',
				assignmentType: 'pathway_alignment',
				resources: {
					plan: 'https://docs.google.com/document/d/1FqM3VbwMoG5anfGHeHP8eIepTsYLa6Px/edit?usp=drive_link&ouid=101351132062150365714&rtpof=true&sd=true',
					slides:
						'https://docs.google.com/presentation/d/1coJWh3-ts3TYvAjj-1FiCEboy8i_bP1C/edit?usp=drive_link&ouid=101351132062150365714&rtpof=true&sd=true',
				},
			},
			{
				id: 'g10-session-5',
				order: 5,
				title: 'Profile Building & Extracurriculars',
				assignmentType: 'profile_building',
				resources: {
					plan: 'https://docs.google.com/document/d/1BAhJ_xfR57_yD6Z2mnz9Tj8oxA1zixrq/edit?usp=drive_link&ouid=101351132062150365714&rtpof=true&sd=true',
					slides:
						'https://docs.google.com/presentation/d/1WRo2-4cZSavN3zZP5UBz-E8usxSGqrfU/edit?usp=drive_link&ouid=101351132062150365714&rtpof=true&sd=true',
				},
			},
			{
				id: 'g10-session-6',
				order: 6,
				title: 'Final 2-3 Minute Oral Presentation',
				assignmentType: 'class_presentation',
				resources: {
					plan: 'https://docs.google.com/document/d/1LqhgkE9azubnAGZjIdNCgGzv7gk8jvTD/edit?usp=drive_link&ouid=101351132062150365714&rtpof=true&sd=true',
					slides:
						'https://docs.google.com/presentation/d/14FQ44y7Bm8jrmNbIbhNH18PBwHwGdKtM/edit?usp=drive_link&ouid=101351132062150365714&rtpof=true&sd=true',
				},
			},
		]),
	},

	{
		id: 'grade-11',
		grade: 11,
		title: 'Grade 11 Core Curriculum',
		sessions: withSessionMeta([
			{
				id: 'g11-session-1',
				order: 1,
				title: 'Career Quiz & Personality Review',
				assignmentType: 'career_quiz',
				resources: {
					plan: 'https://docs.google.com/document/d/1V0aAWpslLeT4gE6tLz3WFkj5eukcQS-WjQgK1X3dnJo/edit?usp=drive_link',
					slides:
						'https://docs.google.com/presentation/d/1-y2MOnvrbf82hcYW59FvLTJUEU5sxgLcph56PXbMO7c/edit?usp=drive_link',
				},
			},
			{
				id: 'g11-session-2',
				order: 2,
				title: 'Country & University Exploration',
				assignmentType: 'country_exploration',
				resources: {
					plan: 'https://docs.google.com/document/d/13cSj6LY0dUQhfNCBD2avzuU3HngNuUB8/edit?usp=drive_link&ouid=101351132062150365714&rtpof=true&sd=true',
					slides:
						'https://docs.google.com/presentation/d/1W5T5gtLn95NdRHkFoTpVy85E2UtTH0re/edit?usp=drive_link&ouid=101351132062150365714&rtpof=true&sd=true',
				},
			},
			{
				id: 'g11-session-3',
				order: 3,
				title: 'Profile Building & Extracurriculars',
				assignmentType: 'profile_building',
				resources: {
					plan: 'https://docs.google.com/document/d/1cYNUYc2gpLBU9FvB_fxeRSGfzmX_wpzt/edit?usp=drive_link&ouid=101351132062150365714&rtpof=true&sd=true',
					slides:
						'https://docs.google.com/presentation/d/1DgHF8QimeivVeC85-lZfmTFvPk25iJOR/edit?usp=drive_link&ouid=101351132062150365714&rtpof=true&sd=true',
				},
			},
			{
				id: 'g11-session-4',
				order: 4,
				title: 'IELTS',
				assignmentType: null,
				resources: {
					plan: 'https://docs.google.com/document/d/12JfxiaOYbF9E_bDca_AHc9-tvVViaH2f/edit?usp=drive_link&ouid=101351132062150365714&rtpof=true&sd=true',
					slides:
						'https://docs.google.com/presentation/d/1Ju4ZgVh410PqdQdMCBdDRZgONqEZmqs0/edit?usp=drive_link&ouid=101351132062150365714&rtpof=true&sd=true',
				},
			},
			{
				id: 'g11-session-5',
				order: 5,
				title: 'Internships',
				assignmentType: null,
				resources: {
					plan: '',
					slides: '',
				},
			},
		]),
	},

	{
		id: 'grade-12',
		grade: 12,
		title: 'Grade 12 Core Curriculum',
		sessions: withSessionMeta([
			{
				id: 'g12-session-1',
				order: 1,
				title: 'Career Quiz & Personality Review',
				assignmentType: 'career_quiz',
				resources: {
					plan: 'https://docs.google.com/document/d/1V0aAWpslLeT4gE6tLz3WFkj5eukcQS-WjQgK1X3dnJo/edit?usp=drive_link',
					slides:
						'https://docs.google.com/presentation/d/1-y2MOnvrbf82hcYW59FvLTJUEU5sxgLcph56PXbMO7c/edit?usp=drive_link',
				},
			},
			{
				id: 'g12-session-2',
				order: 2,
				title: 'Career Reflection Essay',
				assignmentType: 'career_essay',
				resources: {
					plan: 'https://docs.google.com/document/d/13yrd1OBu2WhI8QQcsg39nx36Y7UpvwVm/edit?usp=drive_link&ouid=101351132062150365714&rtpof=true&sd=true',
					slides:
						'https://docs.google.com/presentation/d/1qA6tSOO1tdPyuCYHxlpWrAG6fu7nH02e/edit?usp=drive_link&ouid=101351132062150365714&rtpof=true&sd=true',
				},
			},
			{
				id: 'g12-session-3',
				order: 3,
				title: 'Country & University Exploration',
				assignmentType: 'country_exploration',
				resources: {
					plan: 'https://docs.google.com/document/d/1-9ciTYI13VoEjuipah7oAGI7y6mNQhbN/edit?usp=drive_link&ouid=101351132062150365714&rtpof=true&sd=true',
					slides:
						'https://docs.google.com/presentation/d/1p64mdak7umGuH5yuYuY63yV3xdUVD1cs/edit?usp=drive_link&ouid=101351132062150365714&rtpof=true&sd=true',
				},
			},
			{
				id: 'g12-session-4',
				order: 4,
				title: 'Course Exploration',
				assignmentType: 'university_exploration',
				resources: {
					plan: 'https://docs.google.com/document/d/1zgFI0JTazQpWizEoHy6qFXQloBsxppbl/edit?usp=drive_link&ouid=101351132062150365714&rtpof=true&sd=true',
					slides:
						'https://docs.google.com/presentation/d/1c_hB7RBQ9XpMBvzVQEJYd8lTuxMc4cT6Jdkax_Xp04U/edit?usp=drive_link',
				},
			},
			{
				id: 'g12-session-8',
				order: 5,
				title: 'Universities & Applications',
				assignmentType: null,
				resources: {
					plan: 'https://drive.google.com/file/d/1kSzLBICFRTy-fkrJcHd1xFqxmiWjQa-f/view',
					slides:
						'https://drive.google.com/file/d/1a9dkGiLrK77sSWCfxMhgoV0AqSBVdrDV/view',
				},
			},
			{
				id: 'g12-session-5',
				order: 6,
				title: 'College Essay',
				assignmentType: null,
				resources: {
					plan: 'https://docs.google.com/document/d/1ke_2nkJ6-hhE6SWiv0McHve9cAvSphZd/edit?usp=drive_link&ouid=101351132062150365714&rtpof=true&sd=true',
					slides:
						'https://docs.google.com/presentation/d/1qZjCt_fvwwuLbjBxY2nu2vpikixU8YER/edit?usp=drive_link&ouid=101351132062150365714&rtpof=true&sd=true',
				},
			},
			{
				id: 'g12-session-6',
				order: 7,
				title: 'Resume',
				assignmentType: 'profile_building',
				resources: {
					plan: 'https://docs.google.com/document/d/1Wq0v3tL8obZsnVhhBV3fErlxcv9zCTM4/edit?usp=drive_link&ouid=101351132062150365714&rtpof=true&sd=true',
					slides:
						'https://docs.google.com/presentation/d/18ID0OUA55Dkp0UHdBck0a-V2o9du3iS9/edit?usp=drive_link&ouid=101351132062150365714&rtpof=true&sd=true',
				},
			},
			{
				id: 'g12-session-7',
				order: 8,
				title: 'Scholarships',
				assignmentType: null,
				resources: {
					plan: 'https://drive.google.com/file/d/1MOLqZSVcDGcs7KuUpFZ7EBE4YOo35aNq/view',
					slides:
						'https://drive.google.com/file/d/1kC209Dd8Mfe0-rP9wqheo5w0_sq7b9Wd/view',
				},
			},
		]),
	},
]

export const DEFAULT_GRADE_ID = 'grade-11'
